import { action } from 'satcheljs';

/**
 * This action will get dispatched when show sender on top value is changed from message list setting
 */
const toggleShowSenderOnTop = action('toggleShowSenderOnTop', (newValue: boolean) => ({
    newValue,
}));

export default toggleShowSenderOnTop;
